import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import axios from 'axios'
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure} from "@nextui-org/react";
import BackEndUrl from '../../backURL';
import React from 'react'
const backend = BackEndUrl.domain

const LogoutButton = ({isstaff}) => {
  const {isOpen, onOpen, onClose} = useDisclosure();

  async function Logout() {
    try {
     if(!isstaff){

       const response = await axios.post(backend+"/user-otp-logout",{
        nic:sessionStorage.getItem("nic"),
        mobile:sessionStorage.getItem("mobile")
       } ,{
         headers: {
           Authorization: `Bearer ${sessionStorage.getItem('token')}`,
         }
       })
       sessionStorage.clear(); 
     window.location.href = window.location.href;
 
     }
     else if(isstaff=="Yes"){
       const response = await axios.post(backend+"/staff-otp-logout",{
        nic:sessionStorage.getItem("nic"),
        mobile:sessionStorage.getItem("mobile")
       }, {
         headers: {
           Authorization: `Bearer ${sessionStorage.getItem('token')}`,
         }
       })
       sessionStorage.clear(); 
     window.location.href = window.location.href;
 
     }
 
     
 
 
 
 }
  catch (err) {
    console.error(err)
    sessionStorage.clear(); window.location.href = window.location.href;
 
  }
 }
  return (
 < > <Button isIconOnly onClick={()=>{onOpen()}} >
    <FontAwesomeIcon icon={faRightFromBracket} />
  </Button>
  <>
      
      <Modal 
        size={"md"} 
        isOpen={isOpen} 
        onClose={onClose} 
      
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Logout </ModalHeader>
              <ModalBody>
                <p> 
                 Are you sure you want to log-out?
                </p>
                
              </ModalBody>
              <ModalFooter>
                <Button variant="light" onPress={onClose}>
                  No
                </Button>
                <Button  color="danger" onPress={()=>{Logout()}}>
                  Yes
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  </>
  )
}

export default LogoutButton


 